import { render, staticRenderFns } from "./registerParent.vue?vue&type=template&id=e3e499ea&scoped=true"
import script from "./registerParent.vue?vue&type=script&lang=js"
export * from "./registerParent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3e499ea",
  null
  
)

export default component.exports